import React, { useContext, useState } from 'react';
import { FormContext } from '../metadata/MDForm';
import { ModelContext } from '../metadata/ModelSource';
import { formatMoneyAmount } from '../../utils/formatUtils';

const styles = {
  container: {
    display: 'flex',
    justifyContent: '-webkit-right',
    alignContent: '-webkit-right',
  },
  text: {
    margin: 0,
    fontWeight: 'bold'
  }
};

export const SwitchPremiumSum = ({ attr, cd1, cd2, attrCondition, attrValue }) => {
  const form = useContext(FormContext);
  const model = useContext(ModelContext);
  const { setValueByAttr, getValueByAttr } = form;

  const prefix = form.prefix;
  const risks = form.getValue('risks');

  let cd = cd1;
  if (attrCondition != undefined && attrValue != undefined && cd2 != undefined) {
    let condValue = getValueByAttr(attrCondition);
    if (condValue == attrValue){
      cd = cd1;
    } else {
      cd = cd2;
    }
  }

  let sum = 0;

  if (risks !== undefined) {
    risks.forEach((risk, index) => {
      const premiumAmt = form.getValue(
        `risks[${index}].coverages{coverageCd:${cd}}.writtenPremiumAmt`
      );

      if (premiumAmt === undefined) {
        return sum;
      }
      return (sum += parseFloat(premiumAmt));
    });
  } else {
    const riskIndex = parseInt(
      prefix.substring(prefix.lastIndexOf('[') + 1, prefix.lastIndexOf(']'))
    );
    const value = model.getValue(
      `${prefix}coverages{coverageCd:${cd}}.writtenPremiumAmt`
    );
    const formattedValue = formatMoneyAmount(parseFloat(value));
    sum = formattedValue;
  }

  const formatValue = value => {
    if (value !== undefined || value !== 0) {
      return `${formatMoneyAmount(value)}`;
    } else {
      return '$0.00';
    }
  };

    if (sum == '$NaN') {
      sum = '$0.00';
    }

  return (
      <div style={styles.container}>
        {risks !== undefined ? (
          <p style={styles.text}>{formatValue(sum)}</p>
        ) : (
          <p style={styles.text}>{sum}</p>
        )}
      </div>
    );
};